const normalizeKey = (value: string): string =>
  value
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");

export const buildStableKeyFromName = (name: string, fallback = "item"): string => {
  const normalized = normalizeKey(name);
  return normalized || fallback;
};

export const buildWorkspaceKeyFromName = (workspaceName: string): string =>
  buildStableKeyFromName(workspaceName, "workspace");

export const buildGroupKeyFromName = (groupName: string): string =>
  buildStableKeyFromName(groupName, "group");
